import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import "./Showcase.css"; // Uses the shared CSS!

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "";
const PRODUCT_API = `${API_BASE_URL}/api/products`;
const FALLBACK_IMAGE = "https://via.placeholder.com/400x400?text=No+Image";

const Deals = () => {
  const [deals, setDeals] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchDeals();
  }, []);

  const resolveImageUrl = (img) => {
    if (!img || String(img).trim() === "") return FALLBACK_IMAGE;
    if (img.startsWith("http://") || img.startsWith("https://") || img.startsWith("data:")) return img;
    let cleanPath = img.replace(/^\/?uploads\//, "");
    const baseUrl = API_BASE_URL.endsWith("/") ? API_BASE_URL.slice(0, -1) : API_BASE_URL;
    return `${baseUrl}/uploads/${cleanPath}`;
  };

  const getProductImage = (product) => {
    if (product?.image && String(product.image).trim() !== "") return resolveImageUrl(product.image);
    if (Array.isArray(product?.images) && product.images.length > 0) return resolveImageUrl(product.images[0]);
    return FALLBACK_IMAGE;
  };

  const fetchDeals = async () => {
    try {
      setLoading(true);
      const res = await axios.get(PRODUCT_API);
      let productData = Array.isArray(res.data) ? res.data : (res.data.products || res.data.data || []);

      // FILTER FOR DEALS ONLY
      const dealProducts = productData
        .filter((item) => item.isActive !== false && item.isDeal === true)
        .map((item) => {
          const currentPrice = Number(item.price) || 0;
          const oldPrice = item.originalPrice ? Number(item.originalPrice) : Math.round(currentPrice * 1.25);
          return { ...item, oldPrice, newPrice: currentPrice };
        });

      setDeals(dealProducts);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="showcase-page">
      <div className="page-banner">
        <h1>Best Deals</h1>
      </div>

      <div className="container showcase-grid">
        {loading ? (
          <div className="loading-box"><h2>Loading Deals...</h2></div>
        ) : deals.length === 0 ? (
          <div className="loading-box"><h2>No deals found.</h2></div>
        ) : (
          deals.map((item) => (
            <div className="showcase-card" key={item._id || item.id}>
              <img src={getProductImage(item)} alt={item.name} />
              <div className="showcase-info">
                <h3>{item.name}</h3>
                <div className="price-box">
                  {item.oldPrice > item.newPrice && (
                    <span className="old">₹{item.oldPrice}</span>
                  )}
                  <span className="new">₹{item.newPrice}</span>
                </div>
                <Link to={`/product/${item._id || item.id}`}>
                  <button>Shop Now</button>
                </Link>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default Deals;